import { commitMutation, graphql } from 'react-relay';
import environment from '../data/environment';

const mutation = graphql`
  mutation JobStatusMutation(
    $input: JobStatusInput!
  ) {
    jobStatus(input: $input) {
      job {
        finishedOn
        processedOn
        id
        mongoId
        type
        jobId
        failedReason
        filename
        returnvalue
      }
    }
  }
`;

function commit({
  jobId,
  reportId,
  exportId,
  type,
}, callback) {
  commitMutation(
    environment,
    {
      mutation,
      variables: {
        input: {
          jobId,
          reportId,
          exportId,
          type,
        },
      },
      onCompleted: (res) => {
        callback(null, res.jobStatus.job);
      },
      onError: (err) => {
        callback(err);
      },
    },
  );
}

export default { commit };



// WEBPACK FOOTER //
// ./src/mutations/JobStatusMutation.js